export default __webpack_public_path__ + "media/attendees.6f0bf912.svg";